import type { Timestamp } from 'firebase/firestore'

const MS_PER_DAY = 86_400_000

/** Format a Firestore Timestamp (or Date) as e.g. "14 Jul 2026". Null → "—". */
export function formatDate(value: Timestamp | Date | null | undefined): string {
  if (!value) {
    return '—'
  }
  const date = value instanceof Date ? value : value.toDate()
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
}

/**
 * Whole days between two dates (`end - start`), floored and never negative.
 * Used to compute a completed project's Duration (blueprint §2.4).
 */
export function durationDays(start: Date, end: Date): number {
  const ms = end.getTime() - start.getTime()
  if (Number.isNaN(ms)) {
    return 0
  }
  return Math.max(0, Math.floor(ms / MS_PER_DAY))
}

/** Human-readable file size, e.g. `1536` → `"1.5 KB"`. */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`
  }
  const units = ['KB', 'MB', 'GB', 'TB']
  let value = bytes / 1024
  let unitIndex = 0
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024
    unitIndex += 1
  }
  return `${value.toFixed(1)} ${units[unitIndex]}`
}
